/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountStateResponse } from '../models/AccountStateResponse';
import type { CodeRequest } from '../models/CodeRequest';
import type { LoginRequest } from '../models/LoginRequest';
import type { ProviderAccounts } from '../models/ProviderAccounts';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccountsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Accounts
     * The login providers list-dl knows, each with its stored accounts. Never contains passwords or cookies.
     * @returns ProviderAccounts Successful Response
     * @throws ApiError
     */
    public listAccountsApiV1AccountsGet(): CancelablePromise<Array<ProviderAccounts>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/accounts',
        });
    }
    /**
     * Login
     * Log in. Answers 202 when a verification code has to be submitted next.
     * @returns AccountStateResponse Successful Response
     * @throws ApiError
     */
    public loginApiV1AccountsProviderLoginPost({
        provider,
        requestBody,
    }: {
        provider: string,
        requestBody: LoginRequest,
    }): CancelablePromise<AccountStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/accounts/{provider}/login',
            path: {
                'provider': provider,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Code
     * Submit the verification code of a login that answered 202.
     * @returns AccountStateResponse Successful Response
     * @throws ApiError
     */
    public submitCodeApiV1AccountsProviderCodePost({
        provider,
        requestBody,
    }: {
        provider: string,
        requestBody: CodeRequest,
    }): CancelablePromise<AccountStateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/accounts/{provider}/code',
            path: {
                'provider': provider,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Logout
     * Forget the stored account.
     * @returns void
     * @throws ApiError
     */
    public logoutApiV1AccountsProviderDelete({
        provider,
        flavor = 'com',
    }: {
        provider: string,
        flavor?: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/accounts/{provider}',
            path: {
                'provider': provider,
            },
            query: {
                'flavor': flavor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
